import type { HelpFile } from '../../types/help'
import { TableEmptyStateTestIds } from '../../../testids/TableEmptyStateTestIds'

export const tableEmptyStateHelp: HelpFile = {
  texts: {
    [TableEmptyStateTestIds.tableEmptyState]: 'No rows match the current filters or no data exists yet.',
  },
}
